import React, { useEffect, useState } from 'react';
import Modal from '../../../../shared/ui/modal/Modal';
import s from './QuickPostModal.module.css';
import SelectPage from '../../../landing-page/onboarding-page/SelectPage';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../shared/ui/button/Button';
import { fetchSocialPages } from '../../../../shared/api/socialApi';
import { useAppDispatch } from '../../../../store/store';
const QuickPostModal = ({
    isOpen,
    onClose,
    selectedSocialMedia,
}: {
    isOpen: boolean;
    onClose: () => void;
    selectedSocialMedia: string;
}) => {
    const navigate = useNavigate();
    const [selectedSocialPage, setSelectedSocialPage] = useState('');

    const dispatch = useAppDispatch();
    const handleChangeSocialPage = (option: any) => {
        setSelectedSocialPage(option.value);

        // navigate(
        //     `/generate-quick-post/${selectedSocialMedia}?source=dashboard&page_id=${option.value}`,
        // );
    };

    const handleClose = () => {
        onClose();
    };

    const postProject = () => {
        navigate(
            `/generate-quick-post/${selectedSocialMedia}?source=dashboard&page_id=${selectedSocialPage}`,
        );
    };

    useEffect(() => {
        if (selectedSocialMedia) {
            dispatch(fetchSocialPages(selectedSocialMedia)).then(() => {});
        }
    }, [dispatch, selectedSocialMedia]);

    const isPostDisabled = selectedSocialPage === '';

    return (
        <Modal isOpen={isOpen} onClose={onClose} width="400px">
            <div className={s.container}>
                <h3 className={s.title}>Select a social page to analyze your profile</h3>

                <SelectPage
                    selectedSocial={selectedSocialMedia}
                    onChange={(option) => handleChangeSocialPage(option)}
                    source="scrapping"
                />

                <div className={s.post_modal_buttons}>
                    <Button
                        onClick={handleClose}
                        text="Cancel"
                        style={{
                            background: 'white',
                            color: '#23262A',
                            border: '1px solid #E5E7EB',
                        }}
                    />

                    <Button
                        onClick={postProject}
                        text="Post Now"
                        state={isPostDisabled ? 'disabled' : 'enabled'}
                        style={{
                            background: isPostDisabled ? '#E5E7EB' : '#FFDD35',
                            color: isPostDisabled ? '#9CA3AF' : '#000',
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default QuickPostModal;
